module.exports = __webpack_public_path__ + "static/media/reports.67ea365a.gif";